import { render } from "./VideosSection.vue?vue&type=template&id=166f0a61&scoped=true"
import script from "./VideosSection.vue?vue&type=script&lang=js"
export * from "./VideosSection.vue?vue&type=script&lang=js"

import "./VideosSection.vue?vue&type=style&index=0&id=166f0a61&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-166f0a61"]])

export default __exports__